import { initializeHeader } from "./header";
import { getHtml } from "../apis/templateHtml";
import { navigate } from "../router/router";
import { startLoadingDisplay, endLoadingDisplay } from "../modules/uiManager/UiLoadingDisplay";
import { showPopupAlert } from "../modules/uiManager/UiPopup";
import { fetchCodeMaster, setCodeMaster, isCodeMasterLoaded, populateSelect } from "../modules/codeMasterManager/CodeMasterManager";
import { showSearchModal } from "../modules/uiManager/UiSearchModal";
import { fetchFieldSurveyRequests } from "../apis/fieldSurveyRequestApi";
import { graphqlQuery, fetchOperationPermissions } from "../apis/graphqlClient";
import { openVendorSearch } from "../modules/searchModal/SearchModalConfigs";
import { getOperationPermission, setOperationPermissions, isOperationPermissionsLoaded } from "../modules/permissionManager/PermissionManager";
const PAGE_SIZE = 10;
let requestData = [];
let paginationInfo = {
    page: 1,
    pageSize: PAGE_SIZE,
    totalRecords: 0,
    totalPages: 0,
    hasNext: false,
    hasPrevious: false,
};
const ACTION_MENU_CONFIG = {
    '部門承認待ち(M)': { remand: false, approve: true, history: true, reRequest: false },
    '部門承認済(M)': { remand: false, approve: false, history: true, reRequest: false },
    '部門差戻': { remand: true, approve: false, history: true, reRequest: false },
    '部門中止': { remand: false, approve: false, history: true, reRequest: true },
    '建築確認中': { remand: false, approve: false, history: true, reRequest: false },
    '建築確認済(担当)': { remand: false, approve: false, history: true, reRequest: false },
    '建築差戻': { remand: true, approve: false, history: true, reRequest: false },
    '建築中止': { remand: false, approve: false, history: true, reRequest: true },
    '自動却下': { remand: true, approve: false, history: true, reRequest: false },
    '現調書作成済(設計事務所)': { remand: false, approve: false, history: true, reRequest: false },
    '建築承認済(担当)': { remand: false, approve: false, history: true, reRequest: false },
    '建築承認済(M)': { remand: false, approve: false, history: true, reRequest: false },
    '建築承認済(GM)': { remand: false, approve: false, history: true, reRequest: false },
    '建築承認済(本部長)': { remand: false, approve: false, history: true, reRequest: true },
};
function getSearchParams() {
    const getValue = (id) => {
        const el = document.getElementById(id);
        return el ? el.value.trim() : '';
    };
    return {
        status: getValue('selStatus'),
        internalId: getValue('txtInternalId'),
        handlingType: getValue('selHandlingType'),
        candidateId: getValue('txtCandidateId'),
        storeNo: getValue('txtStoreNo'),
        storeName: getValue('txtStoreName'),
        prefecture: getValue('selPrefecture'),
        contractType: getValue('selContractType'),
        requestCount: getValue('txtRequestCount'),
        submissionMethod: getValue('selSubmissionMethod'),
        designOffice: getValue('txtDesignOffice'),
    };
}
function validateSearchParams(params) {
    if (params.storeNo) {
        const normalized = params.storeNo.replace(/[０-９]/g, (m) => String.fromCharCode(m.charCodeAt(0) - 0xFEE0));
        if (!/^\d+$/.test(normalized)) {
            showPopupAlert({ text: '店番は半角数字で入力してください。', showBackdrop: true });
            return false;
        }
        params.storeNo = normalized;
    }
    if (params.requestCount) {
        const normalized = params.requestCount.replace(/[０-９]/g, (m) => String.fromCharCode(m.charCodeAt(0) - 0xFEE0));
        if (!/^\d+$/.test(normalized)) {
            showPopupAlert({ text: '依頼回数は半角数字で入力してください。', showBackdrop: true });
            return false;
        }
        params.requestCount = normalized;
    }
    if (params.internalId) {
        const normalized = params.internalId.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (m) => String.fromCharCode(m.charCodeAt(0) - 0xFEE0));
        if (!/^[a-zA-Z0-9]+$/.test(normalized)) {
            showPopupAlert({ text: '内製化識別番号は半角英数字で入力してください。', showBackdrop: true });
            return false;
        }
        params.internalId = normalized;
    }
    if (params.candidateId) {
        const normalized = params.candidateId.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (m) => String.fromCharCode(m.charCodeAt(0) - 0xFEE0));
        if (!/^[a-zA-Z0-9]+$/.test(normalized)) {
            showPopupAlert({ text: '候補地番号は半角英数字で入力してください。', showBackdrop: true });
            return false;
        }
        params.candidateId = normalized;
    }
    return true;
}
async function performSearch(page = 1) {
    const params = getSearchParams();
    if (!validateSearchParams(params))
        return;
    try {
        startLoadingDisplay();
        const variables = { page, perPage: PAGE_SIZE };
        Object.entries(params).forEach(([key, value]) => {
            if (value) {
                variables[key] = key === 'requestCount' ? parseInt(value, 10) : value;
            }
        });
        const result = await fetchFieldSurveyRequests(variables);
        requestData = result.items;
        const totalPages = Math.ceil(result.totalCount / result.perPage);
        paginationInfo = {
            page: result.page,
            pageSize: result.perPage,
            totalRecords: result.totalCount,
            totalPages,
            hasNext: result.page < totalPages,
            hasPrevious: result.page > 1,
        };
        const resultCount = document.getElementById('resultCount');
        if (resultCount) {
            resultCount.textContent = `${paginationInfo.totalRecords}件`;
        }
        if (requestData.length === 0) {
            showPopupAlert({ text: '検索結果が0件です。検索条件を変更してください。', showBackdrop: true });
        }
        renderTable();
        updatePaginationDisplay();
    }
    catch (error) {
        console.error('検索エラー:', error);
        showPopupAlert({ text: '検索中にエラーが発生しました。しばらく時間をおいて再度お試しください。', showBackdrop: true });
    }
    finally {
        endLoadingDisplay();
    }
}
const TABLE_COLUMNS = [
    { label: '操作', width: 60 },
    { label: 'ステータス', width: 180 },
    { label: '内製化識別番号', width: 140 },
    { label: '取扱区分', width: 120 },
    { label: '候補地番号', width: 120 },
    { label: '都道府県', width: 80 },
    { label: '店番', width: 70 },
    { label: '店名', width: 130 },
    { label: '契約タイプ', width: 100 },
    { label: '依頼回数', width: 70 },
    { label: '提出方法', width: 100 },
    { label: '設計事務所', width: 140 },
    { label: '依頼書類格納先BOX', width: 150 },
    { label: '建築部承認中BOX', width: 140 },
    { label: '現地調査報告書BOX', width: 150 },
];
function renderTableHeader() {
    const table = document.getElementById('tblRequestList');
    if (!table)
        return;
    const headerHTML = `
    <thead>
      <tr>
        ${TABLE_COLUMNS.map(c => `<th style="min-width:${c.width}px;">${c.label}</th>`).join('\n        ')}
      </tr>
    </thead>
  `;
    table.innerHTML = headerHTML + '<tbody></tbody>';
}
function renderTable() {
    const table = document.getElementById('tblRequestList');
    if (!table)
        return;
    const headerHTML = `
    <thead>
      <tr>
        ${TABLE_COLUMNS.map(c => `<th style="min-width:${c.width}px;">${c.label}</th>`).join('\n        ')}
      </tr>
    </thead>
  `;
    let rowsHTML = '';
    requestData.forEach((req, index) => {
        rowsHTML += `
      <tr>
        <td>
          <div class="action-menu-wrapper" style="position: relative;">
            <button class="action-menu-btn" data-index="${index}" style="background:none;border:none;cursor:pointer;font-size:20px;">
              <span class="material-icons">more_vert</span>
            </button>
            <div class="action-menu-dropdown" data-index="${index}" style="display:none;position:fixed;background:#fff;border:1px solid #ddd;border-radius:4px;box-shadow:0 2px 8px rgba(0,0,0,0.15);z-index:1000;min-width:120px;">
              ${buildActionMenuItems(req.statusName)}
            </div>
          </div>
        </td>
        <td>${escapeHtml(req.statusName)}</td>
        <td>${escapeHtml(req.internalId)}</td>
        <td>${escapeHtml(req.handlingTypeName)}</td>
        <td>${escapeHtml(req.candidateId)}</td>
        <td>${escapeHtml(req.prefectureName)}</td>
        <td>${escapeHtml(req.storeNo)}</td>
        <td>${escapeHtml(req.storeName)}</td>
        <td>${escapeHtml(req.contractTypeName)}</td>
        <td>${req.requestCount}</td>
        <td>${escapeHtml(req.submissionMethodName)}</td>
        <td>${escapeHtml(req.designOffice)}</td>
        <td>${req.boxLink ? `<a href="${escapeHtml(req.boxLink)}" target="_blank">${escapeHtml(req.boxLink)}</a>` : ''}</td>
        <td>${req.approvalBoxLink ? `<a href="${escapeHtml(req.approvalBoxLink)}" target="_blank">${escapeHtml(req.approvalBoxLink)}</a>` : ''}</td>
        <td>${req.reportBoxLink ? `<a href="${escapeHtml(req.reportBoxLink)}" target="_blank">${escapeHtml(req.reportBoxLink)}</a>` : ''}</td>
      </tr>
    `;
    });
    table.innerHTML = headerHTML + `<tbody>${rowsHTML}</tbody>`;
    setupActionMenuListeners();
}
function buildActionMenuItems(status) {
    const config = ACTION_MENU_CONFIG[status];
    if (!config)
        return '<div style="padding:8px;color:#999;">操作なし</div>';
    const op = getOperationPermission('SITE_SURVEY');
    let items = '';
    if (config.remand && (!op || op.ssRevision)) {
        items += '<div class="action-menu-item" data-action="remand" style="padding:8px 16px;cursor:pointer;white-space:nowrap;">差戻修正</div>';
    }
    if (config.approve && (!op || op.ssApprove)) {
        items += '<div class="action-menu-item" data-action="approve" style="padding:8px 16px;cursor:pointer;white-space:nowrap;">承認</div>';
    }
    if (config.history && (!op || op.ssHistory)) {
        items += '<div class="action-menu-item" data-action="history" style="padding:8px 16px;cursor:pointer;white-space:nowrap;">履歴参照</div>';
    }
    if (config.reRequest && (!op || op.ssReRequest)) {
        items += '<div class="action-menu-item" data-action="reRequest" style="padding:8px 16px;cursor:pointer;white-space:nowrap;">再依頼</div>';
    }
    if (!items)
        return '<div style="padding:8px;color:#999;">操作なし</div>';
    return items;
}
function escapeHtml(str) {
    if (!str)
        return '';
    const div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
}
let activeMenuBtn = null;
let activeMenuDropdown = null;
function positionDropdown() {
    if (!activeMenuBtn || !activeMenuDropdown)
        return;
    const rect = activeMenuBtn.getBoundingClientRect();
    activeMenuDropdown.style.top = `${rect.bottom}px`;
    activeMenuDropdown.style.left = `${rect.left}px`;
}
function closeAllDropdowns() {
    document.querySelectorAll('.action-menu-dropdown').forEach((dd) => {
        dd.style.display = 'none';
    });
    activeMenuBtn = null;
    activeMenuDropdown = null;
}
function setupActionMenuListeners() {
    const buttons = document.querySelectorAll('.action-menu-btn');
    buttons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.stopPropagation();
            const index = btn.dataset.index;
            const allDropdowns = document.querySelectorAll('.action-menu-dropdown');
            allDropdowns.forEach((dd) => {
                if (dd.dataset.index !== index) {
                    dd.style.display = 'none';
                }
            });
            const dropdown = document.querySelector(`.action-menu-dropdown[data-index="${index}"]`);
            if (dropdown) {
                const isHidden = dropdown.style.display === 'none';
                if (isHidden) {
                    activeMenuBtn = btn;
                    activeMenuDropdown = dropdown;
                    positionDropdown();
                    dropdown.style.display = 'block';
                }
                else {
                    dropdown.style.display = 'none';
                    activeMenuBtn = null;
                    activeMenuDropdown = null;
                }
            }
        });
    });
    const menuItems = document.querySelectorAll('.action-menu-item');
    menuItems.forEach((item) => {
        item.addEventListener('mouseenter', () => {
            item.style.backgroundColor = '#f5f5f5';
        });
        item.addEventListener('mouseleave', () => {
            item.style.backgroundColor = '';
        });
        item.addEventListener('click', (e) => {
            e.stopPropagation();
            const action = item.dataset.action;
            const wrapper = item.closest('.action-menu-wrapper');
            const btn = wrapper?.querySelector('.action-menu-btn');
            const index = parseInt(btn?.dataset.index || '0', 10);
            const req = requestData[index];
            closeAllDropdowns();
            if (req) {
                switch (action) {
                    case 'remand':
                        navigate(`/field-survey-request-edit/${req.internalId}`);
                        break;
                    case 'approve':
                        navigate(`/field-survey-request-approve/${req.internalId}`);
                        break;
                    case 'history':
                        navigate(`/field-survey-request-history/${req.internalId}`);
                        break;
                    case 'reRequest':
                        navigate(`/field-survey-request-retry/${req.internalId}`);
                        break;
                }
            }
        });
    });
    document.addEventListener('click', closeAllDropdowns);
    window.addEventListener('scroll', positionDropdown, true);
}
function updatePaginationDisplay() {
    const paginationArea = document.getElementById('paginationArea');
    if (!paginationArea)
        return;
    if (paginationInfo.totalPages <= 0) {
        paginationArea.innerHTML = '';
        return;
    }
    paginationArea.innerHTML = `
    <div class="pagination-controls">
      <button class="pagination-btn pagination-prev" ${!paginationInfo.hasPrevious ? 'disabled style="opacity:0.5;cursor:not-allowed;"' : ''}>
        <span class="material-icons">chevron_left</span>
      </button>
      <input type="text" class="pagination-input" id="currentPageInput" value="${paginationInfo.page}" />
      <span class="pagination-separator">/</span>
      <span class="pagination-total">${paginationInfo.totalPages}</span>
      <button class="pagination-btn pagination-next" ${!paginationInfo.hasNext ? 'disabled style="opacity:0.5;cursor:not-allowed;"' : ''}>
        <span class="material-icons">chevron_right</span>
      </button>
    </div>
  `;
    const prevBtn = paginationArea.querySelector('.pagination-prev');
    if (prevBtn && !prevBtn.disabled) {
        prevBtn.addEventListener('click', () => performSearch(paginationInfo.page - 1));
    }
    const nextBtn = paginationArea.querySelector('.pagination-next');
    if (nextBtn && !nextBtn.disabled) {
        nextBtn.addEventListener('click', () => performSearch(paginationInfo.page + 1));
    }
    const pageInput = document.getElementById('currentPageInput');
    if (pageInput) {
        pageInput.addEventListener('change', () => {
            let val = pageInput.value.trim().replace(/[０-９]/g, (m) => String.fromCharCode(m.charCodeAt(0) - 0xFEE0));
            const pageNum = parseInt(val, 10);
            if (isNaN(pageNum) || pageNum < 1 || pageNum > paginationInfo.totalPages) {
                pageInput.value = paginationInfo.page.toString();
                return;
            }
            performSearch(pageNum);
        });
        pageInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter')
                pageInput.blur();
        });
    }
}
function restrictInput(id, mode) {
    const el = document.getElementById(id);
    if (!el)
        return;
    const pattern = mode === 'half-num' ? /[^0-9]/g : /[^a-zA-Z0-9]/g;
    el.addEventListener('input', () => {
        el.value = el.value.replace(pattern, '');
    });
}
function setupInputRestrictions() {
    restrictInput('txtInternalId', 'half-alnum');
    restrictInput('txtCandidateId', 'half-alnum');
    restrictInput('txtStoreNo', 'half-num');
    restrictInput('txtRequestCount', 'half-num');
}
function clearSearchConditions() {
    const textIds = ['txtInternalId', 'txtCandidateId', 'txtStoreNo', 'txtStoreName', 'txtRequestCount', 'txtDesignOffice'];
    textIds.forEach((id) => {
        const el = document.getElementById(id);
        if (el)
            el.value = '';
    });
    const selectIds = ['selStatus', 'selHandlingType', 'selPrefecture', 'selContractType', 'selSubmissionMethod'];
    selectIds.forEach((id) => {
        const el = document.getElementById(id);
        if (el)
            el.value = '';
    });
}
function setupButtons() {
    const searchBtn = document.getElementById('btnSearch');
    if (searchBtn) {
        searchBtn.addEventListener('click', () => performSearch());
    }
    const clearBtn = document.getElementById('btnClear');
    if (clearBtn) {
        clearBtn.addEventListener('click', () => clearSearchConditions());
    }
    const newRequestBtn = document.getElementById('btnNewRequest');
    if (newRequestBtn) {
        newRequestBtn.addEventListener('click', () => {
            navigate('/field-survey-request-new');
        });
    }
    const btnStoreSearch = document.getElementById('btnStoreSearch');
    if (btnStoreSearch) {
        btnStoreSearch.addEventListener('click', () => {
            showSearchModal({
                title: '店舗検索',
                note: '※モック：店番「0」、店名「テスト」などを入力すると結果が表示されます。',
                fields: [
                    { key: 'storeNo', label: '店番', type: 'text', placeholder: '(半角数字)' },
                    { key: 'storeName', label: '店名', type: 'text', placeholder: '' },
                ],
                columns: [
                    { key: 'storeNo', label: '店番', width: '80px' },
                    { key: 'storeName', label: '店名', width: '120px' },
                    { key: 'storeNameKana', label: 'カナ' },
                    { key: 'prefectureName', label: '都道府県' },
                    { key: 'address', label: '住所', width: '200px' },
                ],
                onSearch: async (conditions) => {
                    try {
                        const query = `
              query storeSearch($input: StoreSearchInput) {
                storeSearch(input: $input) {
                  totalCount
                  items {
                    storeNo
                    storeName
                    storeNameKana
                    prefectureName
                    address
                  }
                }
              }
            `;
                        const input = {};
                        if (conditions.storeNo)
                            input.storeNo = conditions.storeNo;
                        if (conditions.storeName)
                            input.storeName = conditions.storeName;
                        const data = await graphqlQuery(query, { input });
                        return data.storeSearch.items || [];
                    }
                    catch {
                        return [];
                    }
                },
                onSelect: (data) => {
                    const setVal = (id, val) => {
                        const el = document.getElementById(id);
                        if (el)
                            el.value = val;
                    };
                    setVal('txtStoreNo', data.storeNo);
                    setVal('txtStoreName', data.storeName);
                },
            });
        });
    }
    const btnDesignOfficeSearch = document.getElementById('btnDesignOfficeSearch');
    if (btnDesignOfficeSearch) {
        btnDesignOfficeSearch.disabled = false;
        btnDesignOfficeSearch.addEventListener('click', () => {
            openVendorSearch('txtDesignOffice', '');
        });
    }
}
function initializeSearchSelects() {
    populateSelect('selStatus', 'status_site_survey', '選択してください');
    populateSelect('selHandlingType', 'handling_type', '選択してください');
    populateSelect('selPrefecture', 'prefecture', '選択してください');
    populateSelect('selContractType', 'contract_type', '選択してください');
    populateSelect('selSubmissionMethod', 'submission_method', '選択してください');
}
export const initializeFieldSurveyRequestList = async () => {
    try {
        startLoadingDisplay();
        const content = await getHtml('/parts/fieldSurveyRequestList.html');
        const subContents = document.getElementById('subContents');
        if (content && subContents) {
            subContents.innerHTML = content;
        }
        await initializeHeader('現地調査依頼');
        if (!isCodeMasterLoaded()) {
            const codeMaster = await fetchCodeMaster();
            setCodeMaster(codeMaster);
        }
        if (!isOperationPermissionsLoaded()) {
            const ops = await fetchOperationPermissions();
            setOperationPermissions(ops);
        }
        initializeSearchSelects();
        setupInputRestrictions();
        renderTableHeader();
        setupButtons();
        const op = getOperationPermission('SITE_SURVEY');
        if (op && !op.ssNewRequest) {
            const btnNew = document.getElementById('btnNewRequest');
            if (btnNew)
                btnNew.style.display = 'none';
        }
        endLoadingDisplay();
    }
    catch (error) {
        console.error('現地調査依頼一覧の初期化に失敗しました:', error);
        endLoadingDisplay();
        throw error;
    }
};
